/**
 * Realtime Abstraction Layer — Entry Point
 * Sprint 1, Story 1.5
 */

/**
 * Realtime Abstraction Layer — Entry Point
 * Sprint 1, Story 1.5 / Updated Sprint 5, Story 5.5
 *
 * Adapter único: Socket.io (o do Supabase foi removido em 2026-09-14).
 */

export type { RealtimeProvider, RealtimeChannel, RealtimePayload, RealtimeEvent, ChannelStatus, PostgresChangesConfig } from './types';
export { socketioRealtimeAdapter } from './socketio-adapter';

import { socketioRealtimeAdapter } from './socketio-adapter';
import type { RealtimeProvider } from './types';

// Active adapter: Socket.io (Express server + nginx /socket.io/ proxy + JWT auth)
export const realtime: RealtimeProvider = socketioRealtimeAdapter;
